export const environment = {
  production: false,
  apiUrl: 'https://lmconsult-ms-dev.azurewebsites.net/',
};
